import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  Grid,
  GridItem,
  Card,
  CardBody,
  CardHeader,
  VStack,
  HStack,
  Badge,
  Icon,
  Flex,
  Spacer,
  List,
  ListItem,
  ListIcon,
  Divider,
  useColorModeValue,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Collapse,
  useDisclosure,
  IconButton,
  SimpleGrid,
  Image
} from '@chakra-ui/react';
import {
  FaCheck,
  FaStar,
  FaCrown,
  FaGraduationCap,
  FaVideo,
  FaUsers,
  FaDownload,
  FaCertificate,
  FaHeadset,
  FaChartLine,
  FaBookOpen,
  FaClock,
  FaWhatsapp,
  FaPhone,
  FaChevronDown,
  FaChevronUp
} from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import Header from '../layout/Header';
import Footer from '../layout/Footer';

const PacksPage = () => {
  const [activeNiveau, setActiveNiveau] = useState("BAC");
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';
  const cardBg = useColorModeValue('white', 'gray.800');

  useEffect(() => {
    // Simulate loading packs data
    setTimeout(() => {
      setPacks([
        {
          id: 1,
          name: "باقة السنة التاسعة",
          nameAr: "من لول للخر | السنة التاسعة", // Changed pack name
          price: 974,
          originalPrice: 1779,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "9eme",
          isPopular: false,
          isFeatured: true,
          color: "#3182CE",
          description: "باقة شاملة لطلاب السنة التاسعة تحتوي على جميع المواد",
          features: [
            { title: "رياضيات", icon: "FaCheck" },
            { title: "فيزياء", icon: "FaCheck" },
            { title: "تقنية", icon: "FaCheck" },
            { title: "علوم طبيعية", icon: "FaCheck" },
            { title: "فرنسية", icon: "FaCheck" },
            { title: "انقليزية", icon: "FaCheck" },
            { title: "عربية", icon: "FaCheck" },
            { title: "حصص مباشرة تفاعلية (lives) 🔴", icon: "FaVideo" }, // Added red circle emoji
            { title: "تسجيلات الحصص المباشرة", icon: "FaVideo" },
            { title: "تلاخيص لجميع المواد (PDF)", icon: "FaDownload" },
            { title: "امتحانات تقييمية", icon: "FaCertificate" },
            { title: "حصص تحفيزية وتنمية الذات", icon: "FaHeadset" }
          ]
        },
        {
          id: 2,
          name: "باقة السنة الثامنة",
          nameAr: "من لول للخر | السنة الثامنة", // Changed pack name
          price: 974,
          originalPrice: 1779,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "8eme",
          isPopular: false,
          isFeatured: true,
          color: "#805AD5",
          description: "باقة شاملة لطلاب السنة الثامنة تحتوي على جميع المواد",
          features: [
            { title: "رياضيات", icon: "FaCheck" },
            { title: "فيزياء", icon: "FaCheck" },
            { title: "تقنية", icon: "FaCheck" },
            { title: "علوم طبيعية", icon: "FaCheck" },
            { title: "فرنسية", icon: "FaCheck" },
            { title: "انقليزية", icon: "FaCheck" },
            { title: "عربية", icon: "FaCheck" },
            { title: "حصص مباشرة تفاعلية (lives) 🔴", icon: "FaVideo" }, // Added red circle emoji
            { title: "تسجيلات الحصص المباشرة", icon: "FaVideo" },
            { title: "تلاخيص لجميع المواد (PDF)", icon: "FaDownload" },
            { title: "امتحانات تقييمية", icon: "FaCertificate" },
            { title: "حصص تحفيزية وتنمية الذات", icon: "FaHeadset" }
          ]
        },
        {
          id: 3,
          name: "باقة السنة السابعة",
          nameAr: "من لول للخر | السنة السابعة", // Changed pack name
          price: 947,
          originalPrice: 1699,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "7eme",
          isPopular: false,
          isFeatured: true,
          color: "#D69E2E",
          description: "باقة شاملة لطلاب السنة السابعة تحتوي على جميع المواد",
          features: [
            { title: "رياضيات", icon: "FaCheck" },
            { title: "فيزياء", icon: "FaCheck" },
            { title: "علوم الحياة و الأرض", icon: "FaCheck" },
            { title: "تقنية", icon: "FaCheck" },
            { title: "فرنسية", icon: "FaCheck" },
            { title: "انقليزية", icon: "FaCheck" },
            { title: "عربية", icon: "FaCheck" },
            { title: "حصص مباشرة تفاعلية (lives) 🔴", icon: "FaVideo" }, // Added red circle emoji
            { title: "تسجيلات الحصص المباشرة", icon: "FaVideo" },
            { title: "تلاخيص لجميع المواد (PDF)", icon: "FaDownload" },
            { title: "امتحانات تقييمية", icon: "FaCertificate" },
            { title: "حصص تحفيزية وتنمية الذات", icon: "FaHeadset" }
          ]
        },
        {
          id: 4,
          name: "باقة السنة الثانية",
          nameAr: "من لول للخر | السنة الثانية", // Changed pack name
          price: 947,
          originalPrice: 1240,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "2eme",
          isPopular: false,
          isFeatured: true,
          color: "#38B2AC",
          description: "باقة شاملة لطلاب السنة الثانية تحتوي على جميع المواد",
          features: [
            { title: "رياضيات", icon: "FaCheck" },
            { title: "GESTION", icon: "FaCheck" },
            { title: "ÉCONOMIE", icon: "FaCheck" },
            { title: "حصص مباشرة تفاعلية (lives) 🔴", icon: "FaVideo" }, // Added red circle emoji
            { title: "تسجيلات الحصص المباشرة", icon: "FaVideo" },
            { title: "تلاخيص لجميع المواد (PDF)", icon: "FaDownload" },
            { title: "امتحانات تقييمية", icon: "FaCertificate" },
            { title: "حصص تحفيزية وتنمية الذات", icon: "FaHeadset" }
          ]
        },
        {
          id: 5,
          name: "باقة السنة الثالثة",
          nameAr: "من لول للخر | السنة الثالثة", // Changed pack name
          price: 947,
          originalPrice: 1240,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "3eme",
          isPopular: false,
          isFeatured: true,
          color: "#E53E3E",
          description: "باقة شاملة لطلاب السنة الثالثة تحتوي على جميع المواد",
          features: [
            { title: "رياضيات", icon: "FaCheck" },
            { title: "GESTION", icon: "FaCheck" },
            { title: "ÉCONOMIE", icon: "FaCheck" },
            { title: "حصص مباشرة تفاعلية (lives) 🔴", icon: "FaVideo" }, // Added red circle emoji
            { title: "تسجيلات الحصص المباشرة", icon: "FaVideo" },
            { title: "تلاخيص لجميع المواد (PDF)", icon: "FaDownload" },
            { title: "امتحانات تقييمية", icon: "FaCertificate" },
            { title: "حصص تحفيزية وتنمية الذات", icon: "FaHeadset" }
          ]
        },
        {
          id: 6,
          name: "باقة البكالوريا",
          nameAr: "من لول للخر | البكالوريا", // Changed pack name
          price: 1247,
          originalPrice: 1799,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "BAC",
          isPopular: true,
          isFeatured: true,
          color: primaryColor,
          description: "الباقة الشاملة لطلاب البكالوريا تحتوي على جميع المواد",
          features: [
            { title: "رياضيات", icon: "FaCheck" },
            { title: "GESTION", icon: "FaCheck" },
            { title: "ÉCONOMIE", icon: "FaCheck" },
            { title: "HISTOIRE", icon: "FaCheck" },
            { title: "GÉOGRAPHIE", icon: "FaCheck" },
            { title: "حصص مباشرة تفاعلية (lives) 🔴", icon: "FaVideo" }, // Added red circle emoji
            { title: "تسجيلات الحصص المباشرة", icon: "FaVideo" },
            { title: "تلاخيص لجميع المواد (PDF)", icon: "FaDownload" },
            { title: "امتحانات تقييمية", icon: "FaCertificate" },
            { title: "حصص تحفيزية وتنمية الذات", icon: "FaHeadset" }
          ]
        }
      ]);
      setLoading(false);
    }, 1000);
  }, []);

  const getIconComponent = (iconName) => {
    const icons = {
      FaVideo: FaVideo,
      FaUsers: FaUsers,
      FaHeadset: FaHeadset,
      FaDownload: FaDownload,
      FaCertificate: FaCertificate,
      FaChartLine: FaChartLine,
      FaBookOpen: FaBookOpen,
      FaStar: FaStar,
      FaGraduationCap: FaGraduationCap,
      FaCrown: FaCrown,
      FaClock: FaClock,
      FaPhone: FaPhone,
      FaCheck: FaCheck
    };
    return icons[iconName] || FaCheck;
  };

  const formatDuration = (duration, type) => {
    const typeMap = {
      'months': duration === 1 ? 'شهر' : 'أشهر',
      'years': duration === 1 ? 'سنة' : 'سنوات'
    };
    return `${duration} ${typeMap[type]}`;
  };

  const niveauGroups = {
    "7eme": "السنة السابعة",
    "8eme": "السنة الثامنة",
    "9eme": "السنة التاسعة",
    "2eme": "السنة الثانية",
    "3eme": "السنة الثالثة",
    "BAC": "البكالوريا"
  };

  const niveauColors = {
    "7eme": "#D69E2E",
    "8eme": "#805AD5",
    "9eme": "#3182CE",
    "2eme": "#38B2AC",
    "3eme": "#E53E3E",
    "BAC": primaryColor
  };

  const NiveauButton = ({ niveau, label, isActive, onClick }) => {
    return (
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <Button
          onClick={onClick}
          size="lg"
          variant={isActive ? "solid" : "outline"}
          colorScheme={isActive ? "yellow" : "gray"}
          bg={isActive ? niveauColors[niveau] : "transparent"}
          color={isActive ? "white" : "gray.700"}
          borderColor={niveauColors[niveau]}
          borderWidth="2px"
          borderRadius="xl"
          px={8}
          py={6}
          _hover={{
            bg: isActive ? niveauColors[niveau] : `${niveauColors[niveau]}20`
          }}
          fontFamily="Cairo, sans-serif"
          fontWeight="bold"
          leftIcon={<Icon as={FaGraduationCap} />}
        >
          {label}
        </Button>
      </motion.div>
    );
  };

  const PackCard = ({ pack }) => {
    const handleWhatsAppClick = () => {
      window.open(`https://wa.me/21622779137`, '_blank');
    };

    const handlePhoneClick = () => {
      window.open(`tel:+21622779137`, '_blank');
    };

    return (
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        whileHover={{ y: -10 }}
      >
        <Card
          bg="green.200" // Changed to sky blue background
          boxShadow={pack.isPopular ? "2xl" : "lg"}
          borderRadius="2xl"
          overflow="hidden"
          position="relative"
          border={pack.isPopular ? `3px solid ${primaryColor}` : "1px solid"}
          borderColor={pack.isPopular ? primaryColor : "gray.200"}
          _hover={{ boxShadow: "2xl" }}
          transition="all 0.3s"
          h="100%"
        >
          {/* Top Left Badge */}
          <Badge 
            position="absolute" 
            top={2} 
            left={2} 
            bg={pack.color}
            color="white"
            px={3}
            py={1}
            borderRadius="full"
            fontSize="sm"
            fontFamily="Cairo, sans-serif"
            fontWeight="bold"
            zIndex={1}
          >
            {pack.niveau === "BAC" ? "بكالوريا" : `سنة ${pack.niveau.charAt(0)}`}
          </Badge>

          {pack.isPopular && (
            <Box
              position="absolute"
              top={0}
              left="50%"
              transform="translateX(-50%)"
              bg={primaryColor}
              color={secondaryColor}
              px={6}
              py={2}
              borderBottomRadius="lg"
              fontWeight="bold"
              fontSize="sm"
              fontFamily="Cairo, sans-serif"
              zIndex={1}
            >
              الأكثر شعبية
            </Box>
          )}

          <CardHeader textAlign="center" pt={pack.isPopular ? 12 : 6}>
            <VStack spacing={4}>
              <Box
                w={16}
                h={16}
                borderRadius="full"
                bg={pack.color}
                display="flex"
                alignItems="center"
                justifyContent="center"
                color="white"
                border={`3px solid ${pack.color}`}
              >
                {/* Replace with your actual logo path */}
                <Image 
                  src="./assets/cobra.png" 
                  alt="Cobra Education Logo"
                  boxSize="80%"
                  objectFit="contain"
                />
              </Box>
              
              <VStack spacing={2}>
                <Heading size="lg" color={secondaryColor} fontFamily="Cairo, sans-serif" fontWeight="bold">
                  {pack.nameAr}
                </Heading>
                <Text fontSize="xl" color="gray.600" textAlign="center" fontFamily="Cairo, sans-serif">
                  {pack.description}
                </Text>
              </VStack>
  {pack.originalPrice && (
                  <HStack spacing={2}>
                    <Text
                      fontSize="3xl"
                      color="red.500" // Changed to green for prix initial
                      textDecoration="line-through"
                      fontFamily="Cairo, sans-serif"
                      fontWeight="bold"
                    >
                      {pack.originalPrice} {pack.currency}
                    </Text>
                  </HStack>
                )}
              <VStack spacing={1}>
                <HStack align="baseline">
                  <Text fontSize="3xl" fontWeight="bold" color="#805AD5"> {/* Changed to red for prix reduit */}
                    {pack.price}
                  </Text>
                  <Text fontSize="3xl" color="gray.600" fontFamily="Cairo, sans-serif">
                    {pack.currency}
                  </Text>
                </HStack>
                
              
                
                <Text fontSize="2xl" color="gray.600" fontFamily="Cairo, sans-serif">
                  لمدة {formatDuration(pack.duration, pack.durationType)}
                </Text>
              </VStack>
            </VStack>
          </CardHeader>

          <CardBody>
            <VStack spacing={6} align="stretch">
              <List spacing={3}>
                {pack.features.map((feature, featureIndex) => (
                  <ListItem key={featureIndex}>
                    <HStack align="start">
                      {feature.icon === "FaVideo" ? (
                        <>
                          <ListIcon as={FaVideo} color="green.500" mt={1} />
                         
                        </>
                      ) : feature.title.includes("تسجيلات") ? (
                        <>
                          <ListIcon as={FaVideo} color="red.500" mt={1} />
                        
                        </>
                      ) : (
                        <ListIcon as={getIconComponent(feature.icon)} color="green.500" mt={1} /> // Changed all check icons to green
                      )}
                      <Text fontSize="xl" fontFamily="Cairo, sans-serif" fontWeight="bold"> {/* Made text bigger */}
                        {feature.title}
                      </Text>
                    </HStack>
                  </ListItem>
                ))}
              </List>

              <Divider />

              <VStack spacing={3}>
                <HStack spacing={2} w="100%">
                  <Button
                    leftIcon={<FaWhatsapp />}
                    variant="outline"
                    size="md" // Made button bigger
                    flex={1}
                    colorScheme="green"
                    fontFamily="Cairo, sans-serif"
                    onClick={handleWhatsAppClick}
                  >
                    واتساب
                  </Button>
                  <Button
                    leftIcon={<FaPhone />}
                    variant="outline"
                    size="md" // Made button bigger
                    flex={1}
                    colorScheme="blue"
                    fontFamily="Cairo, sans-serif"
                    onClick={handlePhoneClick}
                  >
                    اتصال
                  </Button>
                </HStack>
              </VStack>
            </VStack>
          </CardBody>
        </Card>
      </motion.div>
    );
  };

  return (
    <Box dir="rtl">
      <Header />
      
      {/* Hero Section */}
      <Box bg={`linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)`} py={20}>
        <Container maxW="8xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <VStack spacing={6} textAlign="center" color="white">
              <Heading size="2xl" fontFamily="Cairo, sans-serif">
                اختر الباقة المناسبة لك
              </Heading>
              <Text fontSize="xl" maxW="3xl" fontFamily="Cairo, sans-serif">
                باقات مصممة خصيصاً لتلبية احتياجات كل طالب، من السنة السابعة إلى البكالوريا
              </Text>
              <HStack spacing={8} mt={8}>
                <VStack>
                  <Text fontSize="3xl" fontWeight="bold" color={primaryColor}>30%</Text>
                  <Text fontSize="md">خصم على جميع الباقات</Text> {/* Made text bigger */}
                </VStack>
                <VStack>
                  <Text fontSize="3xl" fontWeight="bold" color={primaryColor}>24/7</Text>
                  <Text fontSize="md">دعم فني متواصل</Text> {/* Made text bigger */}
                </VStack>
                <VStack>
                  <Text fontSize="3xl" fontWeight="bold" color={primaryColor}>100%</Text>
                  <Text fontSize="md">ضمان الجودة</Text> {/* Made text bigger */}
                </VStack>
              </HStack>
            </VStack>
          </motion.div>
        </Container>
      </Box>

      <Container maxW="8xl" py={16}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {/* Niveau Selection Buttons */}
          <Box mb={12} overflowX="auto" py={2}>
            <HStack spacing={4} minW="max-content">
              {Object.entries(niveauGroups).map(([niveau, label]) => (
                <NiveauButton
                  key={niveau}
                  niveau={niveau}
                  label={label}
                  isActive={activeNiveau === niveau}
                  onClick={() => setActiveNiveau(niveau)}
                />
              ))}
            </HStack>
          </Box>

          {/* Packs Grid */}
          <AnimatePresence mode="wait">
            <motion.div
              key={activeNiveau}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={6}>
                {packs
                  .filter(pack => pack.niveau === activeNiveau)
                  .map((pack) => (
                    <GridItem key={pack.id}>
                      <PackCard pack={pack} />
                    </GridItem>
                  ))}
              </Grid>
            </motion.div>
          </AnimatePresence>

          {/* FAQ Section */}
          <Box mt={20}>
            <VStack spacing={8} textAlign="center" mb={12}>
              <Heading size="xl" color={secondaryColor} fontFamily="Cairo, sans-serif"> {/* Made text bigger */}
                الأسئلة الشائعة حول الباقات
              </Heading>
              <Text fontSize="xl" color="gray.600" maxW="3xl" fontFamily="Cairo, sans-serif"> {/* Made text bigger */}
                إجابات على أهم الأسئلة التي قد تخطر ببالك حول باقاتنا التعليمية
              </Text>
            </VStack>

            <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={8}>
              {[
                {
                  question: "هل يمكنني تغيير الباقة لاحقاً؟",
                  answer: "نعم، يمكنك ترقية باقتك في أي وقت والاستفادة من الفرق في السعر."
                },
               
                {
                  question: "كيف يتم الدفع؟",
                  answer: "يمكنك الدفع عبر التحويل البنكي أو الدفع النقدي."
                },
                {
                  question: "هل المحتوى متوفر دائماً؟",
                  answer: "نعم، المحتوى متوفر 24/7 ويمكنك الوصول إليه في أي وقت."
                }
              ].map((faq, index) => (
                <GridItem key={index}>
                  <Card bg="blue.50" boxShadow="md" borderRadius="lg"> {/* Changed to sky blue background */}
                    <CardBody>
                      <VStack align="start" spacing={3}>
                        <Heading size="md" color={secondaryColor} fontFamily="Cairo, sans-serif"> {/* Made text bigger */}
                          {faq.question}
                        </Heading>
                        <Text fontSize="md" color="gray.600" fontFamily="Cairo, sans-serif"> {/* Made text bigger */}
                          {faq.answer}
                        </Text>
                      </VStack>
                    </CardBody>
                  </Card>
                </GridItem>
              ))}
            </Grid>
          </Box>

          {/* Contact Section */}
          <Box 
            bg={`linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`}
            borderRadius="2xl"
            p={12}
            mt={16}
            textAlign="center"
          >
            <VStack spacing={6} color="white">
              <Heading size="xl" fontFamily="Cairo, sans-serif"> {/* Made text bigger */}
                هل تحتاج مساعدة في اختيار الباقة المناسبة؟
              </Heading>
              <Text fontSize="xl" maxW="2xl" fontFamily="Cairo, sans-serif"> {/* Made text bigger */}
                فريقنا جاهز لمساعدتك في اختيار الباقة التي تناسب احتياجاتك وميزانيتك
              </Text>
              <HStack spacing={4}>
                <Button
                  leftIcon={<FaWhatsapp />}
                  size="lg"
                  bg="green.500"
                  color="white"
                  _hover={{ bg: 'green.600' }}
                  fontFamily="Cairo, sans-serif"
                  onClick={() => window.open('https://wa.me/21622779137', '_blank')}
                >
                  تواصل عبر واتساب
                </Button>
                <Button
                  leftIcon={<FaPhone />}
                  size="lg"
                  variant="outline"
                  borderColor="white"
                  color="white"
                  _hover={{ bg: 'whiteAlpha.200' }}
                  fontFamily="Cairo, sans-serif"
                  onClick={() => window.open('tel:+21622779137', '_blank')}
                >
                  اتصل بنا الآن
                </Button>
              </HStack>
            </VStack>
          </Box>
        </motion.div>
      </Container>
      
      <Footer />
    </Box>
  );
};

export default PacksPage;